// extracted by mini-css-extract-plugin
module.exports = {"tags":"CatalogDescription__tags","description":"CatalogDescription__description"};